import React from "react";
import BlogThirtyOne from "../component/BlogThirtyOne";

function BlogThirtyOneContainer() {
  return <BlogThirtyOne />;
}
export default BlogThirtyOneContainer;
